"use strict";

var _defineProperty = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/defineProperty");
var _objectWithoutProperties = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _classCallCheck = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/createClass");
var _inherits = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/inherits");
var _possibleConstructorReturn = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/nicholasbucher/Documents/code/jaeger/jaeger-ui/packages/jaeger-ui/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _excluded = ["classNamePrefix", "hidden", "labelFactory", "vertex", "left", "top", "forwardedRef"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
// Copyright (c) 2017 Uber Technologies, Inc.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var Node = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Node, _React$PureComponent);
  var _super = _createSuper(Node);
  function Node() {
    _classCallCheck(this, Node);
    return _super.apply(this, arguments);
  }
  _createClass(Node, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        classNamePrefix = _this$props.classNamePrefix,
        hidden = _this$props.hidden,
        labelFactory = _this$props.labelFactory,
        vertex = _this$props.vertex,
        left = _this$props.left,
        top = _this$props.top,
        forwardedRef = _this$props.forwardedRef,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var p = rest;
      p.style = _objectSpread(_objectSpread({}, p.style), {}, {
        position: 'absolute',
        transform: left == null || top == null ? undefined : "translate(".concat(left, "px,").concat(top, "px)"),
        visibility: hidden ? 'hidden' : undefined
      });
      p.className = "".concat(classNamePrefix, "-Node ").concat(p.className || '');
      return /*#__PURE__*/React.createElement("div", Object.assign({
        ref: forwardedRef
      }, p), labelFactory(vertex));
    }
  }]);
  return Node;
}(React.PureComponent); // ghetto fabulous cast because the 16.3 API is not in flow yet
// https://github.com/facebook/flow/issues/6103
// eslint-disable-next-line react/no-multi-comp
Node.defaultProps = {
  hidden: false,
  left: null,
  top: null
};
var _default = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Node, Object.assign({}, props, {
    forwardedRef: ref
  }));
});
exports.default = _default;